<template>
  <v-app class="app-shell">
    <!-- Navbar -->
    <AppNavbar />

    <!-- Sidebar -->
    <AppSidebar />

    <!-- Main Content -->
    <v-main>
      <v-container fluid class="main-container">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import AppSidebar from "@/components/AppSidebar.vue";
import AppNavbar from "@/components/AppNavbar.vue";
</script>

<style scoped>
.app-shell {
  background: #f4f6f9 !important;
}

.rtl {
  direction: rtl;
}

.main-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 22px 26px 60px;
}
</style>
